import { fromJS, Map } from "immutable";
import { FETCH_SAMPLE_PROJECTS_SUCCESS } from "~/store/action_types";

const results = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_SAMPLE_PROJECTS_SUCCESS: {
      if (!action.response) {
        return state;
      }
      return fromJS(action.response);
    }
    default:
      return state;
  }
};

export default results;
